export default {
  bg: "#FFFFFF",
  text: "#1a2b49",
  highlight: "#cfa14c"
};
